import React from "react";
import { useState, useEffect } from "react";
import CsvExportModal from "../../../../../../components/generic/CsvExportModal";

/**
 * formats manage connections table data for CSV export
 * @param {Array.<Object>} tableData raw table data from the manage connections page
 * @param {Boolean} exportModalVisible show modal if true
 * @param {Function} handleCancelModal close modal callback
 * @returns
 */
const ExportConnectionsBroadModal = (props) => {
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    if (!props.tableData || props.tableData.length < 1) {
      return;
    }

    const newExportData = props.tableData.map((sourceGroup) => {
      return {
        institution_name: sourceGroup.institution_name,
        "no._connections": sourceGroup.connection_count,
        source: sourceGroup.source,
      };
    });
    setExportData(newExportData);
  }, [props.tableData]);

  return (
    <CsvExportModal
      data={exportData}
      fileName={"external-connections"}
      downloadMessage={"Download information for ### external connection(s)."}
      modalVisible={props.exportModalVisible}
      handleCancelModal={props.handleCancelModal}
    />
  );
};

export default ExportConnectionsBroadModal;
